<template>
  <div class="home">
    <van-nav-bar
      :style="{ background: `${sessionStorage.colorCode} !important`}"
      :title="$t('PackageDetail.title')"
      left-arrow
      fixed
      @click-left="$router.push('/Dishes')"
    >
    </van-nav-bar>
    <div v-if="detail">
      <div class="dish_content">
        <van-image
          v-if="detail.image"
          width="130px"
          height="130px"
          :src="detail.image.path"
        />
        <van-image v-else width="130px" height="130px" src="" />
        <div class="info">
          <div
            class="noExceed"
            style="height: 30px;font-size: 16px;line-height: 30px;"
          >
            {{ detail.name }}
          </div>
          <div class="noExceed" style="font-size: 16px;line-height:16px;">
            {{ detail.name_en }}
          </div>
          <div class="dish_footer">
            <van-rate
              style="height: 16px;"
              v-model="detail.level"
              readonly
              :size="16"
              gutter="3px"
              icon="./static/img/Recommend-s.png"
              void-icon="./static/img/Recommend.png"
            />
            <div class="fontLine">
              <span class="currentPrice"
                >{{ sessionStorage.getItem("currency") }}
                {{
                  detail.type == "o"
                    ? detail.original_price
                    : detail.special_price
                }}</span
              >&nbsp;&nbsp;&nbsp;<span
                class="oldPrice"
                v-show="detail.type == 's'"
                >{{ sessionStorage.getItem("currency")
                }}{{ detail.original_price }}</span
              >
            </div>
          </div>
          <p
            style="font-size: 14px;color: #666;padding: 0;margin-bottom: 10px;margin-top: 10px;word-break: break-all;"
          >
            {{ detail.introduction }}
          </p>
        </div>
      </div>
      <div style="height: 3px;width: 100%;background-color: #b7b7b7;"></div>
      <div class="dishList" v-if="detail.tags && detail.tags.data">
        <template v-for="(tag, index) in detail.tags.data">
          <div class="dishItem" v-if="tag.menus.length > 0" :key="index">
            <div
              style="height: 3px;width: 100%;background-color: #F3F5F7;"
            ></div>
            <div class="dishTitle noExceed">
              {{ tag.name }}
            </div>
            <draggable
              v-model="tag.menus"
              handle=".dragIcon"
              chosen-class="chosen"
              force-fallback="true"
              group="people"
              @start.stop="onStart"
              @end.stop="onEnd"
              :move="onMove"
            >
              <div
                class="dishChild"
                v-for="(menu, key) in tag.menus"
                :key="`menu${key}`"
              >
                <div class="icon">
                  <van-icon name="./static/img/drag.png" class="dragIcon" />
                </div>
                <div
                  class="dishChild_content"
                  :style="
                    typeof checkMenuIndex[index] == 'object'
                      ? checkMenuIndex[index].indexOf(key) != -1
                        ? {
                            border: `2px solid ${sessionStorage.colorCode}`,
                            background: sessionStorage.colorCode,
                            color: '#fff'
                          }
                        : { border: `2px solid ${sessionStorage.colorCode}` }
                      : checkMenuIndex[index] == key
                      ? {
                          border: `2px solid ${sessionStorage.colorCode}`,
                          background: sessionStorage.colorCode,
                          color: '#fff'
                        }
                      : { border: `2px solid ${sessionStorage.colorCode}` }
                  "
                >
                  <template v-if="tag.is_choiced == 1">
                    <van-image
                      v-if="menu.image"
                      class="noflex"
                      :style="{
                        border: `2px solid ${sessionStorage.colorCode}`
                      }"
                      width="40"
                      height="40"
                      :src="menu.image.path"
                      @click="changeChildDish(index, menu.target_id, key, 0)"
                    />
                    <van-image
                      v-else
                      class="noflex"
                      :style="{
                        border: `2px solid ${sessionStorage.colorCode}`
                      }"
                      width="40"
                      height="40"
                      src=""
                      @click="changeChildDish(index, menu.target_id, key, 0)"
                    />
                  </template>
                  <template v-else>
                    <van-image
                      v-if="menu.image"
                      class="noflex"
                      :class="[
                        checkMenuIndex[index] == key ? 'actChild' : 'childImg'
                      ]"
                      :style="{
                        border: `2px solid ${sessionStorage.colorCode}`
                      }"
                      width="40"
                      height="40"
                      :src="menu.image.path"
                      @click="changeChildDish(index, menu.target_id, key, 0)"
                    />
                    <van-image
                      v-else
                      class="noflex"
                      :class="[
                        checkMenuIndex[index] == key ? 'actChild' : 'childImg'
                      ]"
                      :style="{
                        border: `2px solid ${sessionStorage.colorCode}`
                      }"
                      width="40"
                      height="40"
                      src=""
                      @click="changeChildDish(index, menu.target_id, key, 0)"
                    />
                  </template>

                  <div class="childTitle">
                    <div
                      class="childTitle1 noExceed"
                      @click="changeChildDish(index, menu.target_id, key, 0)"
                    >
                      {{ menu.name }}
                    </div>
                  </div>
                  <div style="float: right;margin-right:5px">
                    {{ sessionStorage.getItem("currency")
                    }}{{ menu.fill_price }}
                  </div>
                </div>
                <template>
                  <div class="fr" @click="showTaste(index, key)">
                    <img
                      src="../../static/img/notes.png"
                      :style="{
                        width: '30px',
                        height: '30px',
                        border: `2px solid ${sessionStorage.colorCode}`,
                        borderRadius: '10px',
                        padding: '5px'
                      }"
                    />
                  </div>
                </template>
              </div>
            </draggable>
          </div>
        </template>
      </div>
    </div>
    <div style="height: 50px;background: #F3F5F7;"></div>
    <van-popup
      v-model="isTasteShow"
      position="bottom"
      :style="{ height: '75%' }"
    >
      <van-cell-group>
        <van-cell>
          <div style="font-size: 16px;" slot="title">
            {{ $t("PackageDetail.note") }}
          </div>
          <van-icon
            slot="right-icon"
            name="./static/img/dele_staff.png"
            size="26px"
            @click="isTasteShow = false"
          />
        </van-cell>
      </van-cell-group>
      <div v-if="actPerfer" class="tasteGropu">
        <template v-for="(item, index) in actPerfer">
          <div
            class="tasteItem"
            v-if="item.category.data.length > 0"
            :key="index"
          >
            <div class="tasteItemTitle">{{ item.name }}</div>
            <span
              class="is_choiced tagsBox"
              v-if="actPerfer[index].is_choiced == 1"
            >
              <div
                v-for="(val, key) in item.category.data"
                :key="key"
                class="tasteItemRadio"
                :style="[
                  childResult[index][key] == val.id
                    ? {
                        background: sessionStorage.colorCode,
                        border: `1px solid ${sessionStorage.colorCode}`,
                        color: '#ffffff'
                      }
                    : { border: `1px solid ${sessionStorage.colorCode}` }
                ]"
                @click="changeResult(index, key, val.id)"
              >
                {{ val.name }}
                <span v-if="val.price != 0"
                  >{{ sessionStorage.getItem("currency") }}
                  {{ val.price }}</span
                >
              </div>
            </span>
            <span class="tagsBox" v-else>
              <div
                v-for="(val, key) in item.category.data"
                :key="key"
                class="tasteItemRadio"
                :style="[
                  childResult[index][0] == val.id
                    ? {
                        background: sessionStorage.colorCode,
                        border: `1px solid ${sessionStorage.colorCode}`,
                        color: '#ffffff'
                      }
                    : { border: `1px solid ${sessionStorage.colorCode}` }
                ]"
                @click="changeResult(index, key, val.id)"
              >
                {{ val.name }}
                <span v-if="val.price != 0"
                  >{{ sessionStorage.getItem("currency") }}
                  {{ val.price }}</span
                >
              </div>
            </span>
          </div>
        </template>
        <div class="tasteItem">
          <div class="tasteItemTitle">{{ $t("PackageDetail.remark") }}</div>
          <van-field
            :style="{ border: `1px solid ${sessionStorage.colorCode}` }"
            v-model="actRemark"
            rows="3"
            autosize
            type="textarea"
            maxlength="80"
            :placeholder="$t('PackageDetail.inputRemark')"
            show-word-limit
            style="text-indent: 10px;border:1px solid #2f75f4;border-radius: 5px;"
          />
        </div>
      </div>
      <div style="width: 100%;height: 50px;">
        <van-button
          :style="{ background: sessionStorage.colorCode }"
          style="width: 90%;height: 35px;margin-left: 5%;margin-top: 7px;line-height: 35px;"
          round
          @click="saveChange()"
          >{{ $t("PackageDetail.certain") }}</van-button
        >
      </div>
    </van-popup>
  </div>
</template>

<script>
import draggable from "vuedraggable";
export default {
  components: {
    draggable
  },
  data() {
    return {
      detail: {},
      isTasteShow: false,
      actPerfer: [],
      actRemark: "",
      menus_id: [],
      tags_id: [],
      fill_price: [],
      remarks: [],
      perferResult: [],
      childResult: [],
      actIndex: "",
      currency: "",
      startItem: "",
      endItem: "",
      data: {},
      checkMenuIndex: []
    };
  },
  mounted: function() {
    this.getPackageDetail();
    this.getCurrency();
  },
  methods: {
    // 获取套餐菜品详情
    getPackageDetail() {
      this.$axios({
        method: "get",
        url: this.$build + "/api/menu/" + this.$route.params.id + "/takeIndex"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.detail = res.data.data;

            let menuArr = []; //移除那些没有menus的数据
            let tagsDataArr = res.data.data.tags.data;
            for (var i = 0; i < tagsDataArr.length; i++) {
              var temp = {};
              temp.key = i;
              temp.id = "";
              var remarkArr = [];
              var perfer = [];
              var price = 0;
              if (tagsDataArr[i].is_choiced == 1) {
                if (tagsDataArr[i].menus.length > 0) {
                  menuArr.push(tagsDataArr[i]);
                  this.checkMenuIndex.push([0]);
                  temp.id = [tagsDataArr[i].menus[0].target_id];
                  price = [tagsDataArr[i].menus[0].fill_price];
                  for (let k = 0; k < tagsDataArr[i].menus.length; k++) {
                    let perferChild = [];
                    if (tagsDataArr[i].menus[k].perfer.length > 0) {
                      for (
                        let j = 0;
                        j < tagsDataArr[i].menus[k].perfer.length;
                        j++
                      ) {
                        if (
                          tagsDataArr[i].menus[k].perfer[j].category.data
                            .length > 0
                        ) {
                          perferChild.push(
                            tagsDataArr[i].menus[k].perfer[j].category.data[0]
                              .id
                          );
                        }
                      }
                    } else {
                      perferChild.push("");
                    }
                    perfer.push(perferChild);
                    remarkArr.push("");
                  }
                  this.fill_price.push(price);
                }
              } else {
                if (tagsDataArr[i].menus.length > 0) {
                  menuArr.push(tagsDataArr[i]);
                  this.checkMenuIndex.push(0);
                  console.log(this.checkMenuIndex, "查看数据666");
                  temp.id = tagsDataArr[i].menus[0].target_id;
                  price = tagsDataArr[i].menus[0].fill_price;
                  for (
                    var j = 0;
                    j < tagsDataArr[i].menus[0].perfer.length;
                    j++
                  ) {
                    if (
                      tagsDataArr[i].menus[0].perfer[j].category.data.length > 0
                    ) {
                      perfer.push(
                        tagsDataArr[i].menus[0].perfer[j].category.data[0].id
                      );
                    }
                  }
                  this.fill_price.push(price);
                }
              }
              if (tagsDataArr[i].menus.length > 0) {
                if (tagsDataArr[i].is_choiced == 1) {
                  this.perferResult.push(perfer);
                  this.remarks.push(remarkArr);
                } else {
                  this.perferResult.push(perfer);
                  this.remarks.push("");
                }
                this.menus_id.push(temp);
              }
            }
            this.detail.tags.data = menuArr;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // 弹出偏好设置，并设置该偏好的数据
    showTaste(index, key) {
      // this.actIndex=index;
      // this.actPerfer=this.detail.tags.data[index].menus[key].perfer;
      // this.actRemark=this.remarks[index];
      // this.childResult=this.perferResult[index];
      // this.isTasteShow=true;
      let oldindex = this.actIndex;
      let oldindexkey = this.actIndexKey;
      if (this.detail.tags.data[index].is_choiced == 1) {
        this.actPerfer = this.detail.tags.data[index].menus[key].perfer;
        this.actRemark = this.remarks[index][key]
          ? this.remarks[index][key]
          : "";
        this.actIndex = index;
        this.actIndexKey = key;
        this.isChoiced = 1;
      } else {
        this.actPerfer = this.detail.tags.data[index].menus[key].perfer;
        this.actRemark = this.remarks[index] ? this.remarks[index] : "";
        this.actIndex = index;
        this.actIndexKey = key;
        this.isChoiced = 0;
      }
      this.childResult = [];
      for (var i = 0; i < this.actPerfer.length; i++) {
        if (this.actPerfer[i].category.data.length > 0) {
          this.childResult[i] = [];
          this.childResult[i].push(this.actPerfer[i].category.data[0].id);
          // console.log(this.childResult);
        }
      }
      this.isTasteShow = true;
    },
    // 切换标签
    changeResult(index, key, id) {
      if (this.actPerfer[index].is_choiced == 1) {
        let arr = this.childResult[index];
        let type = arr.indexOf(id);
        type == -1 ? (arr[key] = id) : arr.splice(type, 1, "");
        this.$set(this.childResult, index, arr);
      } else {
        let arr = this.childResult[index];
        arr[0] = arr[0] == id ? "" : id;
        this.$set(this.childResult, index, arr);
      }
    },
    // 点击修改选择单品
    changeChildDish(index, id, key, type) {
      // console.log("***********************************");
      this.actPerfer = this.detail.tags.data[index].menus[key].perfer;
      this.actIndex = index;

      if (this.detail.tags.data[index].is_choiced == 0) {
        this.menus_id[index].id = id;
        this.$set(this.checkMenuIndex, index, key);
        this.fill_price[index] = this.detail.tags.data[index].menus[
          key
        ].fill_price;
        if (type == 0) {
          let perferId = [];
          for (let i in this.actPerfer) {
            perferId.push(this.actPerfer[i].category.data[0].id);
          }
          this.childResult = perferId ? perferId : [];
          this.$set(this.perferResult, this.actIndex, this.childResult);
        }
      } else {
        // 点击修改选择单品
        var arr = [];
        if (typeof this.checkMenuIndex[index] == "number") {
          arr.push(this.checkMenuIndex[index]);
          var i = arr.indexOf(key);
          if (i == -1) {
            arr.push(key);
          } else {
            if (arr.length > 1) {
              arr.splice(i, 1);
            }
          }
        } else {
          arr = this.checkMenuIndex[index];
          if (type == 1) {
            var i = arr.indexOf(key);
            if (i == -1) {
              arr.push(key);
            }
          } else {
            var i = arr.indexOf(key);
            if (i == -1) {
              arr.push(key);
            } else {
              if (arr.length > 1) {
                arr.splice(i, 1);
              }
            }
          }
        }
        function compare(val1, val2) {
          return val1 - val2;
        }
        arr.sort(compare);
        this.$set(this.checkMenuIndex, index, arr);
        var arrId = [],
          priceId = [];
        for (var j in arr) {
          arrId.push(this.detail.tags.data[index].menus[arr[j]].target_id);
          priceId.push(this.detail.tags.data[index].menus[arr[j]].fill_price);
        }
        this.menus_id[index].id = arrId;
        this.fill_price[index] = priceId;
        let perferId = [];
        for (let i in this.actPerfer) {
          perferId.push(this.actPerfer[i].category.data[0].id);
        }
        this.childResult = perferId ? perferId : [];
      }
      console.log(this.checkMenuIndex);
    },
    saveChange() {
      this.$set(this.remarks, this.actIndex, this.actRemark);
      this.$set(this.perferResult, this.actIndex, this.childResult);
      this.isTasteShow = false;
      this.actRemark = "";
      this.childResult = [];
    },
    onStart(e) {
      this.drag = true;
      console.log(e, "开始");
    },
    onEnd(e) {
      this.disabled = true;
      this.data = {
        pivot_id: this.startItem.id,
        pivot_ids: this.endItem.id,
        target_id: this.startItem.target_id
      };
      if (this.startItem.pid == this.endItem.pid) {
        this.sort();
      } else {
        this.$toast({
          type: "fail",
          message: this.$t("EditDish.prompt")
        });
      }
    },
    onMove(e, originalEvent) {
      //拖拽位置
      this.startItem = e.draggedContext.element;
      console.log(this.startItem);
      //停靠位置
      this.endItem = e.relatedContext.element;
      if (e.draggedContext.element) return false;
    },
    // 排序
    sort() {
      this.$toast.loading({
        message: "loading...",
        forbidClick: true
      });
      this.$axios({
        method: "PATCH",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/menu/MenusUpDown",
        data: this.data
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.getPackageDetail();
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
          this.$toast.clear();
        })
        .catch(err => {
          this.$toast.clear();
          this.$toast({
            type: "fail",
            message: this.$t("EditDish.message")
          });
        });
    },
    // 获取店铺设置的货币
    getCurrency() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url:
          this.$build + "/api/store/" + sessionStorage.actShopId + "/currency"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.currency = res.data.data.unit;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("PackageDetail.message")
          });
        });
    }
  }
};
</script>
<style scoped>
/deep/ .van-nav-bar .van-icon {
  font-size: 26px;
  color: #fff;
}
/deep/ .van-field__body > input {
  text-align: right;
}
/deep/ .van-picker__cancel,
/deep/ .van-picker__confirm {
  color: #2f75f4;
}
/deep/ .van-divider {
  border-width: 2px;
}
/deep/ .van-info {
  border-color: #000;
}
/deep/ .dish_content .van-image {
  padding: 5px 10px 10px;
}
/deep/ .van-image img {
  border-radius: 6px;
  max-width: 25rem;
  margin: 0 auto;
}
/deep/ .ShopCartBox .van-popup .van-cell {
  position: fixed;
  z-index: 999;
}
.noflex {
  border-radius: 8px;
  position: relative;
  left: -1px;
}
.dish_content {
  display: flex;
}
.dish_footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 5px;
}
.home {
  width: 100%;
  height: auto;
  background-color: #fff;
}
.currentPrice {
  font-size: 20px;
  font-weight: 600;
  color: #fe2a00;
  /* color: #ff6666; */
}
.oldPrice {
  color: #bcbcbc;
  text-decoration: line-through;
}
.info {
  /* width: 90%;
  margin-left: 5%; */
  width: calc(90% - 110px);
  height: auto;
  position: relative;
}
.fontLine {
  padding-bottom: 10px;
  font-size: 14px;
}
.setPerfer {
  position: absolute;
  width: 35px;
  height: 35px;
  bottom: 10px;
  right: 0px;
}
.flexNone {
  flex: none;
}
.cart_left {
  width: 70%;
  height: 34px;
  line-height: 34px;
  float: left;
}
.cart_right {
  width: 30%;
  height: 34px;
  line-height: 26px;
  float: right;
  text-align: right;
  display: flex;
  justify-content: right;
}
.cart_right_btn {
  height: 34px;
  line-height: 34px;
  font-size: 16px;
  color: #222;
  padding: 5px 35px;
  font-weight: 600;
  font-size: 18px;
}
.total_price {
  /* width: 120px; */
  height: 34px;
  line-height: 34px;
  text-indent: 10px;
  font-size: 20px;
  font-weight: 600;
  /* float: right; */
  text-align: right;
  margin-right: 10px;
  /* color: #fff; */
}
.tasteGropu {
  width: 90%;
  margin-left: 5%;
  font-size: 16px;
  height: auto;
}
.tasteItem {
  width: 100%;
  height: auto;
  color: #000;
}
.tasteItemTitle {
  width: 100%;
  height: 45px;
  line-height: 45px;
}
.tasteItemRadio {
  padding: 10px 20px;
  font-size: 14px;
  border-radius: 5px;
  margin-left: 10px;
  margin-bottom: 10px;
  color: #000;
}
.tasteItemRadio_act {
  background-color: #2f75f4;
  color: #fff;
}
.dishList {
  width: 100%;
  min-height: 80px;
  font-size: 14px;
  margin-bottom: 50px;
}
.dishItem {
  width: 90%;
  margin-left: 5%;
  min-height: 80px;
}
.dishTitle {
  width: 100%;
  height: 36px;
  line-height: 36px;
}
.dishChild {
  width: 100%;
  /* height: 42px;
  line-height: 42px; */
  padding-bottom: 5px;
  display: flex;
  display: -webkit-flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  z-index: 1;
}
.childTitle {
  flex: auto;
  height: 42px;
  text-indent: 10px;
  width: 100px;
  display: flex;
  align-items: center;
}
.childTitle1 {
  width: 100%;
  height: 20px;
  line-height: 20px;
}
.selChild {
  position: absolute;
  left: 0px;
  top: 0px;
  z-index: 2;
}
.actChild {
  border: 0.125rem solid #2f75f4;
  /* border-radius: 0.1875rem; */
  border-radius: 10px;
}
.childImg {
  border: 0.125rem solid #ddd;
  /* border-radius: 0.1875rem; */
  border-radius: 10px;
}
.van-button__text {
  color: #fff;
}
.icontext {
  position: absolute;
  font-size: 14px;
  right: 0px;
}
/*购物车样式*/
.cartDetail {
  width: 100%;
  height: auto;
  margin-top: 20px;
}
.cartItem {
  width: 90%;
  margin-left: 5%;
  position: relative;
}
.cart_dish {
  width: 100%;
  overflow: hidden;
}
.cart_dish_name {
  width: 80%;
  height: 60px;
  line-height: 60px;
  text-indent: 5px;
}
.cart_dish_icon {
  width: 80%;
  height: 40px;
  line-height: 40px;
}
.cart_dish_price {
  width: 20%;
  height: 35px;
  line-height: 35px;
  text-align: right;
  color: #aaa;
}
.cart_dish_des {
  width: calc(100% - 60px);
  height: 20px;
  line-height: 20px;
  font-size: 13px;
  color: #ccc;
}
.dish {
  display: flex;
}
.son_dish > .cart_dish_name {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
}
.son_dish > .cart_dish_price {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
}
.son_dish > .cart_dish_des {
  height: 18px;
  line-height: 18px;
  font-size: 12px;
}
.icon_group {
  height: 35px;
  line-height: 35px;
}
.realPrice {
  color: #fb2525;
  font-weight: 600;
}
.inDot {
  width: 24px;
  height: 24px;
  background: #ee0a24;
  border-radius: 50%;
  position: fixed;
  z-index: 2;
}
.tasteBtn {
  width: 50px;
  height: 32px;
  /* background:url('/static/img/Option.png'); */
  background-size: contain;
}
.mright {
  position: absolute;
  right: 0.625rem;
}
.mleft {
  position: absolute;
  right: 6.25rem;
}
@media screen and (min-width: 480px) {
  .mright {
    position: absolute;
    right: 2.5rem;
  }
  .mleft {
    position: absolute;
    right: 8.75rem;
  }
}
.reduceBtn,
.addBtn {
  border-radius: 8px;
  padding: 5px;
}
.tagsBox {
  display: flex;
  flex-wrap: wrap;
}
.dishChild_content {
  display: flex;
  align-items: center;
  width: 100%;
  margin-right: 10px;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/Shop/PackageDetail.vue